import { describeResource } from '@siteless/resource';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

const BallotsCompletedResource = describeResource('BallotsCompletedResource', {
  get: async () => {

    const value: Record<string, boolean> = {};

    (await getDocs(
      query(
        collection(database, 'users'),
        where(`ballotData.${thisOscarsYear}.isCompleted`, '==', true)
      )
    )).forEach(
        document => {
          value[document.id] = true
        },
      );

    return value;
  },
});

export default BallotsCompletedResource;
